export function openLink(link: string, target: "_self" | "_blank" = "_self") {
  window.open(link, target, "noopener,noreferrer");
}
